import { useQuery } from '@tanstack/react-query'
import { api } from '../../../api/client'
import { useAccountAction } from './useAccountAction'

type AdminFlag = { isAdmin: boolean }

/** Marks the account a StoreKeeper admin: the app can then show the server's load (GET /api/v1/admin/load). */
export function AdminFlagCard({ accountId }: { accountId: string }) {
	const url = `/api/v1/admin/accounts/${accountId}/admin`
	const flag = useQuery({ queryKey: ['admin-account', accountId, 'admin'], queryFn: () => api.get<AdminFlag>(url) })
	const set = useAccountAction(accountId, (isAdmin: boolean) => api.put<AdminFlag>(url, { isAdmin }))

	return (
		<section className="card stack">
			<label className="row">
				<input
					type="checkbox"
					checked={flag.data?.isAdmin ?? false}
					disabled={!flag.data || set.isPending}
					onChange={(e) => set.mutate(e.target.checked)}
				/>
				<span>
					StoreKeeper admin
					<span className="small muted"> · can see the server’s load in the app</span>
				</span>
			</label>
			{(flag.error ?? set.error) && <p className="error small">{(flag.error ?? set.error)!.message}</p>}
		</section>
	)
}
